import { DocumentState } from "src/app/core/document-list/models/documentState";
import { UserViewModel } from "../../auth/models/user.viewmodel";
import { AddressTypeEnum } from "./enums/AddressTypeEnum";
import { BuildingTypeEnum } from "./enums/BuildingTypeEnum";
import { ColumnTypes } from "./enums/ColumnTypeEnum";
import { SurveyStatus } from "./enums/SurveySurveyStatus";

export class BuildingSurveyViewModel {
  buildingId: string;
  addressId: string;
  surveyId: string;
  allInGroupReadyToInside: boolean;
  insideSurveyId: string;
  addressLomKey: string;
  buildingLomKey: string;
  buildingGroupId: string;
  buildingType: BuildingTypeEnum;
  addressType: AddressTypeEnum;
  street: string;
  number: number;
  suffix: string;
  outsideStartTime: Date;
  isMainAddress: boolean;
  surveyType: string;
  surveyStatus: SurveyStatus;
  outsideEngineer: UserViewModel;
  figure: string;
  isChecked: boolean; // property for table checkbox
  isCollapsed: boolean = true; // property for table collapse
  coordinates: Coordinate[];
  totalNumberOfUnits: number;
  postalCode: string;
  isMDU: boolean;
  city: string;
  areaCity: string;
  areaId: string;
  fiberHood: string;
  block: string;
  tsaDocumentStatus?: DocumentState;
  hiddenData: string;
  isPrefill: boolean;
  tsaId: string;
  hasOngoingValidateSurvey: boolean;
  hasFailedValidateSurvey: boolean;
  hasSucceededValidateSurvey: boolean;

  constructor(
    buildingId?: string,
    addressId?: string,
    surveyId?: string,
    insideSurveyId?: string,
    lamKey?: number,
    lomKey?: number,
    buildingGroupId?: string,
    street?: string,
    number?: number,
    suffix?: string,
    outsideStartTime?: Date,
    surveyType?: string,
    surveyStatus?: string,
    outsideEngineer?: UserViewModel,
    coordinates?: Coordinate[],
    totalNumberOfUnits?: number,
    isMDU?: boolean
  ) {
    this.isChecked = false;
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }

  getFullAddress() {
    return `${this.street} ${this.number} ${this.suffix} ${this.city} ${this.postalCode}`.replace(
      / +(?= )/g,
      ""
    );
  }

  getShortAddress() {
    return `${this.street} ${this.number} ${this.suffix}`.replace(
      / +(?= )/g,
      ""
    );
  }
}

export class Coordinate {
  Id: string;
  posX: string;
  posY: string;
  isCoordinatesMiddleBuilding: boolean;

  constructor(cord?: {
    id?: string;
    posX?: string;
    posY?: string;
    isCoordinatesMiddleBuilding: boolean;
  }) {
    this.posX = cord?.posX;
    this.posY = cord?.posY;
    this.Id = cord?.id;
    this.isCoordinatesMiddleBuilding = cord?.isCoordinatesMiddleBuilding;
  }
}

export class ColumnDefinition<T> {
  field: string;
  header: string;
  visibleOnPortrait: boolean;
  hasFilter: boolean;
  type?: ColumnTypes;
  template?: string;
  transform?: (data: T) => any;
  filterSearch?: boolean;
  hasEmptyValue?: boolean;
  ignoredFilterValues?: any[];
}
